<template>
    <div class="drks" v-loading.fullscreen.lock="loading">
        <!-- :data="data" -->
        <el-upload class="upload-demo"
                   ref="upload"
                   :action="uploadUrl"
                   :on-preview="handlePreview"
                   :on-remove="handleRemove"
                   :file-list="fileList"
                   :auto-upload="false"
                   multiple
                   :before-upload="handleBefore"
                   :headers="headers"
                   accept=".xlsx,.xls"
                   :on-success="success"
                   :on-error="error">
            <template #trigger>
                <el-button size="small" type="primary">选取文件</el-button>
            </template>
            <div class="button">
                <el-button @click="submitUpload">开始导入</el-button>
                <el-button @click="goback">取消</el-button>
                <el-button @click="download">单位列表下载</el-button>
                <el-button @click="templateDownload">单位示例列表下载</el-button>
            </div>
        </el-upload>
    </div>
</template>

<script>
    import url from "@/api/config.js";
    import { downloadDivs } from '@/api/div.js'
    export default {
        name: "drks",
        data() {
            return {
                fileList: [],
                uploadUrl: "",
                headers: {
                    session: window.$cookies.get("session"),
                    zone: window.$cookies.get("zone"),
                },
                loading: false,
                publicPath: process.env.BASE_URL

            };
        },
        created() {
            if(localStorage.getItem('ipUrl')){
                let ipUrl = localStorage.getItem('ipUrl')
                this.uploadUrl = `${ipUrl}/divs/importDivs`;
            }else{
                this.uploadUrl = `${url.baseUrl.dev}divs/importDivs`;
            }
        },
        methods: {
            templateDownload() {
                var link = document.createElement("a");
                link.href = `${this.publicPath}static/单位列表导入模板.xlsx`;
                link.click();
            },
            download() {
                this.loading = true;
                downloadDivs()
                    .then((res) => {
                        if (res.type == 'application/json') {
                            this.$alert('服务器繁忙或暂时维护，请稍后再试', '提示', {
                                confirmButtonText: '确定',
                                type: 'error',
                            });
                        } else {
                            var blob = new Blob([res], { type: "application/vnd.ms-excel" });
                            var url = URL.createObjectURL(blob);
                            var link = document.createElement("a");
                            link.download = "单位导入列表.xlsx";
                            link.href = url;
                            link.click();
                        }
                        this.loading = false;
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
            },
            error(err) {
                this.loading = false;
            },
            success(response) {
                if (response.status == 0) {
                    this.$message.success("导入成功!");
                } else {
                    //alert(response.phrase + "\n" + "错误码:" + response.status)
                    this.$alert(response.phrase + "\n" + "错误码:" + response.status, '提示', {
                        confirmButtonText: '确定'
                    })
                }
                this.loading = false;
            },
            goback() {
                this.$router.push({ name: '单位列表' })
            },
            handleBefore(file) {
                this.loading = true;
                // const self = this;
                // self.data.zone = "test";
                const isExcel1 =
                    file.type ===
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                const isExcel2 = file.type === "application/vnd.ms-excel";
                if (!isExcel1 && !isExcel2) {
                    this.$message.error("上传文件只能是excel!");
                    return isExcel1 && isExcel2;
                }
            },
            submitUpload() {
                this.$refs.upload.submit();
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            handleExceed(files, fileList) {
                this.$message.warning(
                    `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
                    } 个文件`
                );
            },
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${file.name}？`);
            },
        },
    };
</script>

<style scoped>
    .drks {
        height: 500px;
        width: 80%;
        margin: 0 auto;
        margin-top: 100px;
    }

        .drks .button {
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: 100px;
        }
</style>